import { Box, Button, Modal } from "@mui/material";
import { modalStyle } from "../../../utils/modal-style";
import { editSimulation } from "../../../services/simulations-service";

export default function DoneSimulationModal({ id, open, setOpen }) {
  const accessToken = localStorage.getItem("token");
  const handleClose = () => setOpen(false);

  const handleSubmit = async () => {
    try {
      const edit = await editSimulation(accessToken, {
        id,
        status: "concluida",
      });
      console.log(edit);
      if (edit.status !== 200) throw Error;
      alert("Simulação concluída com sucesso.");

      window.location.reload(true);
    } catch (error) {
      alert("Algo deu errado.");
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box className="box-container" sx={modalStyle}>
        <p>{`Tem certeza que deseja concluir a simulação ${id}?`}</p>
        <div className="buttons-container">
          <Button onClick={handleSubmit} variant="contained">
            Sim
          </Button>
          <Button onClick={handleClose} variant="outlined">
            Não
          </Button>
        </div>
      </Box>
    </Modal>
  );
}
